<template>
  <div>
    <search-profile-data @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showImportModal"
          v-if="isShowMenu('profile_datas/import')"
        >导入</a-button>

        <a-button
          type="primary"
          @click="showGenerateModal"
          v-if="isShowMenu('profile_datas/generate_profiles')"
        >生成 Profile</a-button>

        <a-button
          type="primary"
          @click="handleDelete"
          v-if="isShowMenu('profile_datas/delete')"
        >删除</a-button>

        <a-button type="primary" @click="exportData">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <import-profile-datas
      v-if="isShowImportModal"
      :visible.sync="isShowImportModal"
      @completed="fetchData"
    />

    <generate-profiles-from-profile-datas
      v-if="isShowGenerateModal"
      :visible.sync="isShowGenerateModal"
      :iccids="generateIccids"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findProfileDatas, exportProfileDatas, destroyProfileDatas } from '@/api/profile_data'
import Pagination from '@/components/Pagination'
import SearchProfileData from '@/views/profile_datas/Search'
import ImportProfileDatas from '@/views/profile_datas/import'
import GenerateProfilesFromProfileDatas from '@/views/profile_datas/generate'
import { exportExcel } from '@/api/excel'

export default {
  name: 'ProfileDataList',
  components: {
    Pagination,
    SearchProfileData,
    ImportProfileDatas,
    GenerateProfilesFromProfileDatas
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowImportModal: false,
      isShowGenerateModal: false,
      generateIccids: [],
      selectedRowKeys: [],
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    columns() {
      return [
        { title: 'IMSI', dataIndex: 'imsi', width: 160, fixed: 'left' },
        { title: 'ICCID', dataIndex: 'iccid', width: 200, fixed: 'left' },
        { title: '状态', dataIndex: 'status_text', width: 100 },
        { title: 'PIN1', dataIndex: 'pin1', width: 100 },
        { title: 'PIN2', dataIndex: 'pin2', width: 100 },
        { title: 'PUK1', dataIndex: 'puk1', width: 100 },
        { title: 'PUK2', dataIndex: 'puk2', width: 100 },
        { title: 'KI', dataIndex: 'ki', width: 160, ellipsis: true },
        { title: 'OPC', dataIndex: 'opc', width: 160, ellipsis: true },
        { title: 'GSM_ICCID', dataIndex: 'gsm_iccid', width: 180 },
        { title: 'ACC', dataIndex: 'acc', width: 100 },
        { title: 'AD', dataIndex: 'ad', width: 100 },
        { title: 'ADM1', dataIndex: 'adm1', width: 120 },
        { title: 'SMSP', dataIndex: 'smsp', width: 140, ellipsis: true },
        { title: 'MSISDN', dataIndex: 'msisdn', width: 140 },
        { title: 'OPLMN', dataIndex: 'oplmn', width: 140, ellipsis: true },
        { title: 'FPLMN', dataIndex: 'fplmn', width: 140, ellipsis: true },
        { title: 'KIC1', dataIndex: 'kic1', width: 120, ellipsis: true },
        { title: 'KID1', dataIndex: 'kid1', width: 120, ellipsis: true },
        { title: 'KIK1', dataIndex: 'kik1', width: 120, ellipsis: true },
        { title: '供应商', dataIndex: 'profile_supplier_name', width: 140 },
        { title: '导入时间', dataIndex: 'created_at', width: 170 }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showImportModal() {
      this.isShowImportModal = true
    },
    showGenerateModal() {
      const selected = this.data.filter((row) => this.selectedRowKeys.includes(row.id))
      this.generateIccids = selected.map((row) => row.iccid).filter(Boolean)
      this.isShowGenerateModal = true
    },
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findProfileDatas(this.query).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    },
    buildExportParams() {
      const params = Object.assign({}, this.query)
      if (this.selectedRowKeys.length > 0) {
        params.ids = this.selectedRowKeys.slice()
      }
      return params
    },
    exportData() {
      exportProfileDatas(this.buildExportParams()).then((res) => {
        if (res.code === 0 && res.data.is_direct_download) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    },
    handleDelete() {
      if (this.selectedRowKeys.length === 0) {
        this.$warning({ title: '请先勾选要删除的数据', content: '' })
        return
      }
      const that = this
      this.$confirm({
        title: '确认删除选中的 ProfileData？',
        content: `共 ${this.selectedRowKeys.length} 条`,
        onOk() {
          return destroyProfileDatas({ ids: that.selectedRowKeys }).then((res) => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.fetchData()
            }
          })
        }
      })
    }
  }
}
</script>
